"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.printOptions = exports.wrapInQuotes = void 0;
const wrapInQuotes = (text) => `'${text}'`;
exports.wrapInQuotes = wrapInQuotes;
exports.printOptions = {
    printWidth: 300,
    tabWidth: 4,
    useTabs: false,
    useSnippetSyntax: true
};
//# sourceMappingURL=text-formatting.js.map